import React, { useState } from 'react';
import { AlertTriangle } from 'react-feather';
import { API_BASE_URL } from '../../config/api';
import { useNavigate } from 'react-router-dom';
import "../billing/CancelAccount.css";

const CancelAccount = ({ onError }) => {
  // This state is now used to show/hide the confirmation step.
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isCanceling, setIsCanceling] = useState(false);
  const navigate = useNavigate();

  const handleConfirmCancel = async () => {
    setIsCanceling(true);
    onError(null); // Clear previous errors

    try {
      const token = localStorage.getItem('access_token');
      const ap_token=localStorage.getItem('ap_token');
      const response = await fetch(`${API_BASE_URL}/api/cancel-account`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ap_token,
        }),
      });

      if (!response.ok) {
        // Try to parse error message from API response
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.message || 'Failed to cancel account');
      }

      localStorage.clear();
      navigate('/signup', { replace: true });

    } catch (error) {
      onError(error.message || 'Failed to cancel account. Please contact support.');
      console.error('Error canceling account:', error);
      // Hide the confirmation buttons on error to allow the user to try again later
      setShowConfirmation(false); 
    } finally {
      setIsCanceling(false);
    }
  };

  return (
    <div className="cancel-account-section">
      <h2 className="section-title danger-zone-title">
        <AlertTriangle className="section-icon" />
        Cancel Account
      </h2>

      <div className="warning-card">
        <p>Warning: Canceling your account is a permanent action that will:</p>
        
        {/* IMPROVEMENT: Using a semantic list (<ul>) is better for accessibility and styling. */}
        <ul className="cancellation-consequences">
          <li>Immediately stop all AI assistant services</li>
          <li>Delete your AI assistant configuration</li>
          <li>Remove access to all features</li>
        </ul>

        {/* FIX: Conditional rendering based on the 'showConfirmation' state. */}
        {!showConfirmation ? (
          <button
            onClick={() => setShowConfirmation(true)}
            className="cancel-button"
          >
            Cancel Account
          </button>
        ) : (
          <div className="cancel-modal-overlay">
            <div className="confirmation-prompt">
              <p className="confirmation-text">Are you sure? This cannot be undone.</p>
              <div className="confirmation-actions">
                <button
                  onClick={() => setShowConfirmation(false)}
                  disabled={isCanceling}
                  className="button-secondary"
                >
                  Go Back
                </button>
                <button
                  onClick={handleConfirmCancel}
                  disabled={isCanceling}
                  className="cancel-button"
                >
                  {isCanceling ? 'Canceling...' : 'Yes, Cancel Permanently'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CancelAccount;
